import VBottomNav from './VBottomNav'

VBottomNav.install = function install (Vue) {
  Vue.component(VBottomNav.name, VBottomNav)
}

export default VBottomNav



// WEBPACK FOOTER //
// ./src/components/VBottomNav/index.js